import { render, staticRenderFns } from "./visit-module.vue?vue&type=template&id=0bee85a3&scoped=true"
import script from "./visit-module.vue?vue&type=script&lang=js"
export * from "./visit-module.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.24_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_esdk3aqwspx5xq2g2xm6lubema/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bee85a3",
  null
  
)

export default component.exports